import {
  VStack,
  Text,
  OrderedList as CKOrderedList,
  ListItem,
} from '@chakra-ui/react'

import { titleStyle, containerStyle, listItemStyle } from './styles'

interface Props {
  id?: string
  title: string
  items: string[]
}

function OrderedList({ id, title, items }: Props): React.ReactElement {
  return (
    <VStack id={id} spacing="2" sx={containerStyle}>
      <Text sx={titleStyle}>{title}</Text>
      <CKOrderedList>
        {items.map((item, index) => {
          return (
            <ListItem key={`${index}-${item}`} sx={listItemStyle}>
              {item}
            </ListItem>
          )
        })}
      </CKOrderedList>
    </VStack>
  )
}

export default OrderedList
